import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { IAM_ENVS, IamAuthGrantConfig } from '@msi/commandcentral-common-header';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideClientHydration()]
};


const CLIENT_ID = 'CCAdmin';
const SCOPES = ['CCAdmin', 'openid', 'profile', 'email', 'CCRuleService'];


export function getAppSpecificIamConfig() {
  const origin = window.origin;
  const host = new URL(origin).host;
  let type;
  if (host.includes('localhost')) {
    type = 'local';
  } else {
    type = host.split('.')[1];
  }
  let IDM;
  let isDevOrStage = false;
  const parent = document.referrer;
  if (parent.includes('admin2')) {
    sessionStorage.setItem('Admin', 'admin2');
  }
  switch (type) {
    case 'local':
    case 'dev':
      IDM = IAM_ENVS.IDM_MASTER;
      isDevOrStage = true;
      break;
    case 'stage':
    case 'usgov-stage':
      IDM = IAM_ENVS.IDM_MASTER;
      isDevOrStage = true;
      break;
    case 'commandcentral':
    case 'ent':
    case 'prod':
      if (host.includes('.commandcentral.ca')) {
        IDM = IAM_ENVS.IDM_CA;
      }
      else if (host.includes('.commandcentral.net.au')) {
        IDM = IAM_ENVS.IDM_AU;
      }
      else {
        IDM = IAM_ENVS.IDM_US;
      }
      break;
    case 'usgov':
      IDM = IAM_ENVS.IDM_US;
      break;
    case 'sec':
      IDM = IAM_ENVS.IDM_SEC_CA;
      if (host.includes('preprod')) {
        IDM = IAM_ENVS.IDM_PRE_PROD_SEC_CA;
      }
      break;
    case 'fed':
      IDM = IAM_ENVS.IDM_FED_PROD;
      if (host.includes('stage')) {
        IDM = IAM_ENVS.IDM_FED_STAGE;
      }
      break;
    default:
      IDM = IAM_ENVS.IDM_US;
      break;
  }
  const config: IamAuthGrantConfig = {
    scopes: SCOPES,
    clientId: CLIENT_ID,
    developmentMode: false,
    singlePreprod: isDevOrStage,
    idmUrl: IDM,
  };
  return config;
}
